define('editor/edit/map/controls/boundaries',['durandal/app', 'plugins/http', 'jquery', 'knockout'], function (app, http, $, ko) {
    var control = function (options) {
        var self = this;

        self.editorMapId = options.editorMapId;
        self.map = options.mapControl;
        self.featureGroup = L.featureGroup().addTo(self.map);
        self.layerLeafletIdDictionary = [];
        self.editingLayerId = null; // layer currently under edit (to enable things like dragging etc..)
        self.boundaries = ko.observableArray([]);
        self.lastboundaryrequestdata;

        self.debounce = function (func, wait, immediate) {
            var timeout;
            return function () {
                var context = this, args = arguments;
                var later = function () {
                    timeout = null;
                    if (!immediate) func.apply(context, args);
                };
                var callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) func.apply(context, args);
            };
        };

        self.initialise = function () {
            self.registerEventHandlers();
        };

        self.registerEventHandlers = function () {
            app.on('layers:newData', self.onNewData);
            app.on('layer:editing', self.editBoundary);
            app.on('layers:updated', self.refreshBoundaryLayers);
            app.on('layer:saved', self.lockLayerAfterEdit);
            app.on('layer:visibility', self.onToggleBoundaryVisibility);
            app.on('layers:deleted', self.deleteBoundaries);
            app.on('map:boundaries:new', function () {
                self.clearShapes();
                self.disableRefresh = true;
            });

            app.on('map:boundaries:exitNew', function () {
                self.disableRefresh = false;
            });
            self.map.on('moveend', self.onMapMoveEnd);
        };

        self.destroy = function () {
            app.off('layers:newData', self.onNewData);
            app.off('layer:editing', self.editBoundary);
            app.off('layers:updated', self.refreshBoundaryLayers);
            app.off('layer:saved', self.lockLayerAfterEdit);
            app.off('layer:visibility', self.onToggleBoundaryVisibility);
            app.off('layers:deleted', self.deleteBoundaries);
            app.off('map:boundaries:new');
            app.off('map:boundaries:exitNew');
            self.map.off('moveend', self.onMapMoveEnd);
        };

        self.onNewData = function (layers) {
            self.layers = layers;
            self.refreshBoundaries();
        };

        self.onToggleBoundaryVisibility = function (layer) {
            self.refreshBoundaryLayers([layer]);
        };

        self.deleteBoundaries = function (layers) {
            var deletedLayersLen = layers.length,
                layerToDelete,
                boundaryToDelete,
                labelToDelete;

            for (var i = 0; i < deletedLayersLen; i++) {
                layerToDelete = layers[i];
                boundaryToDelete = self.layerLeafletIdDictionary[layerToDelete.id()];
                labelToDelete = self.layerLeafletIdDictionary[layerToDelete.id() + '_marker'];

                if (!boundaryToDelete) {
                  // no boundary layer on the map with this id - must be another layer not dealt with by this controller (e.g. a marker)
                  return;
                }

                var boundary = ko.utils.arrayFirst(self.boundaries(), function (b) {
                    return b.boundaryId === layerToDelete.state().boundaryId();
                });

                if (boundary) {
                    self.boundaries.remove(boundary);
                }

                if (boundaryToDelete) {
                    self.featureGroup.removeLayer(boundaryToDelete);

                    delete self.layerLeafletIdDictionary[layerToDelete.id()];
                }

                if (labelToDelete) {
                    self.featureGroup.removeLayer(labelToDelete);

                    delete self.layerLeafletIdDictionary[layerToDelete.id() + '_marker'];
                }

                self.layers.remove(layerToDelete);
            }
        };

        self.refreshBoundaries = function () {
            if (!self.layers().length) {
                return;
            }

            var boundaryIds = [];

            for (var i = 0; i < self.layers().length; i++) {
                var layer = self.layers()[i];

                if (layer.type() === 'Boundary' && layer.visible()) {
                    boundaryIds.push(layer.state().boundaryId());
                }
            }

            if (!boundaryIds.length) {
                return;
            }

            app.trigger('spinner:show');

            self.fetchBoundaries(boundaryIds).then(function () {
                self.clearShapes();
                for (var i = 0; i < self.layers().length; i++) {
                    var layer = self.layers()[i];

                    if (layer.type() === 'Boundary') {
                        var boundary = ko.utils.arrayFirst(self.boundaries(), function (b) {
                            return b.boundaryId === layer.state().boundaryId();
                        });

                        self.renderLayerBoundary(layer, boundary);
                        self.renderLayerLabel(layer);
                    }
                }
            })
            .always(function() {
                app.trigger('spinner:hide');
            });
        };

        self.refreshBoundaryLayers = function (layers) {
            var boundarylayerstatechanged = false;
            for (var i = 0; i < layers.length; i++) {
                var layer = layers[i];
                if (layer && layer.type && layer.type() === 'Boundary') {
                    var boundary = ko.utils.arrayFirst(self.boundaries(), function(b) {
                        return b.boundaryId === layer.state().boundaryId();
                    });
                    self.renderLayerBoundary(layer, boundary);
                    self.renderLayerLabel(layer);

                    // if a boundary layer has been turned on, we need to update the boundaries layer
                    // as we only get back visible boundaries
                    if (layer.visible()) {
                        boundarylayerstatechanged = true;
                    }
                }
            }

            // if any one boundary has been turned on refresh boundaries
            if (boundarylayerstatechanged) {
                self.refreshBoundaries();
            }
        };

        self.fetchBoundaries = function (boundaryIds) {
            var bounds = self.map.getBounds();

            var url = '/api/boundaries/',
                data = {
                    boundaryIds: boundaryIds,
                    zoom: self.map.getZoom(),
                    swLat: bounds._southWest.lat,
                    swLon: bounds._southWest.lng,
                    neLat: bounds._northEast.lat,
                    neLon: bounds._northEast.lng
                };

            if (!self.requestdataarequal(self.lastboundaryrequestdata,data)) {
                self.boundaries([]);
                self.lastboundaryrequestdata = data;
                return http.post(url, data).then(function (response) {
                    if (response.success) {
                        ko.utils.arrayPushAll(self.boundaries, response.data.boundaries);
                    }
                });
            }
            var fakehttp = Promise;
            fakehttp.prototype.always = function (func) {
                func();
            };
            return Promise.resolve();
        };

        self.renderLayerBoundary = function (layer, boundary) {
            layer.state().className = "item-id-" + layer.id();

            var featureOptions = {
                style: function () {
                    return ko.toJS(layer.state());
                },
                onEachFeature: function (feature, geoLayer) {
                    geoLayer.on('mouseover', function () {
                        app.trigger('layer:item-selected', layer.id());
                    });

                    geoLayer.on('mouseout', function () {
                        app.trigger('layer:item-deselected', layer.id());
                    });
                } 
            };

            try {
                //remove any existing boundary with the same Id
                var fGroupLayerId = self.layerLeafletIdDictionary[layer.id()];

                if (fGroupLayerId) {
                    self.featureGroup.removeLayer(fGroupLayerId);

                    delete self.layerLeafletIdDictionary[layer.id()];
                }

                if (layer.visible() && boundary && boundary.geojson) {
                    // create a geojson class representing our shape
                    var geojson = L.geoJson(boundary.geojson, featureOptions);
                    geojson.addTo(self.featureGroup);
                    geojson.bringToBack();
                    self.layerLeafletIdDictionary[layer.id()] = geojson._leaflet_id;
                }

            } catch (e) {
                // tried to import invalid geojson?
                app.showMessage('Layer data invalid for: "' + layer.name() + '"<br/><br/>"' + e.message + '"', 'Invalid Layer Data');
            }
        };

        self.renderLayerLabel = function (layer) {
            var fGroupLayerId = self.layerLeafletIdDictionary[layer.id() + '_marker'];

            if (fGroupLayerId) {
                self.featureGroup.removeLayer(fGroupLayerId);

                delete self.layerLeafletIdDictionary[layer.id() + '_marker'];
            }

            if (layer.visible() && layer.state().labelVisible()) {
                var labelOptions = {},
                    classNames = [
                        'marker-icon',
                        'marker-label-center',
                        'marker-label-' + layer.state().textSize(),
                        'marker-label-shadow-' + layer.state().textShadow()
                    ],
                    labelStyles = [];
                labelStyles.push("color: " + (layer.state().labelTextColor()) + ";");
                if (layer.state().textShadow() === 'on') {
                    var color = layer.state().textShadowColor(),
                        val;

                    if (color.indexOf('#FFF') === 0) {
                        val = '0 0 0.3em #FFF, 0 0 0.3em #FFF, 0 0 0.3em #FFF, 0 0 0.3em #FFF, 0 0 0.3em #FFF, 0 0 0.3em #FFF;';
                    } else {
                        val = '0 0 0.3em ' + color + ';';
                    }

                    labelStyles.push("text-shadow: " + val);
                }
                var text = layer.state().labelText().convertNewLinesToHtml();
                var html = '<span style=\"' + labelStyles.join(' ') + '\">' + text + '</span>';
                labelOptions.html = html;
                labelOptions.className = classNames.join(' ');
                var labelCoords = {
                    lat: layer.state().labelLat(),
                    lng: layer.state().labelLon()
                };
                var customMarker = L.divIcon(labelOptions);
                var marker = new L.Marker(labelCoords, {
                    icon: customMarker,
                    zIndexOffset: 100,
                    draggable: self.editingLayerId === layer.id()
                });
                marker.on('dragend', function(event) {
                    // we dont update the layer state here,
                    // instead just raise an event and let the edit panel do it
                    var newPos = event.target.getLatLng();
                    var id = layer.id();
                    app.trigger('marker:moved', { newPos: newPos, id: id });
                });
                marker.addTo(self.featureGroup);
                self.layerLeafletIdDictionary[layer.id() + '_marker'] = marker._leaflet_id;
            }
        };

        self.clearShapes = function () {
            if (self.featureGroup) {
                self.featureGroup.clearLayers();
            }
        };

        self.editBoundary = function (layer) {
            if (layer.type() === 'Boundary') {
                self.editingLayerId = layer.id();
                self.renderLayerLabel(layer);
            }
        };

        self.lockLayerAfterEdit = function(layer) {
            if (layer.type() === 'Boundary') {
                self.editingLayerId = null;
                self.refreshBoundaryLayers([layer]);
            }
        };

        self.onMapMoveEnd = self.debounce(function () {
            if (!self.disableRefresh) {
                self.refreshBoundaries();
            }
        }, 2000);

        self.requestdataarequal = function (data1, data2) {
            if (data1 == null || data2 == null) return false;
            if (data1.zoom != data2.zoom) return false;
            if (data1.swLat != data2.swLat) return false;
            if (data1.swLon != data2.swLon) return false;
            if (data1.neLat != data2.neLat) return false;
            if (data1.neLon != data2.neLon) return false;
            if (data1.boundaryIds.length != data2.boundaryIds.length) return false;
            data1.boundaryIds.forEach(function (item, index) {
                if (item != data2[index]) return false;
            });
            return true;
        }
    };

    return control;
});

